module.exports = __webpack_public_path__ + "static/media/c5bannerModulF_small.55ab02a3.jpg";